import styled, { css } from 'styled-components';

export const ShimmerEffect = css`
  .shimmer {
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    background: linear-gradient(
      105deg,
      transparent 10%,
      rgb(255 255 255) 25%,
      transparent 30%,
      transparent 50%
    );

    width: 120%;
    height: 100%;
    animation: move_continue 2s;
    animation-iteration-count: infinite;
    animation-delay: 1s;
  }

  @keyframes move_continue {
    0% {
      left: 0;
      opacity: 0.4;
    }

    10% {
      opacity: 0.5;
    }

    60% {
      opacity: 0.8;
    }
    90% {
      opacity: 0.6;
    }

    100% {
      left: 82%;
    }
  }
`;

export const BackPopupCover = styled.div`
  background-color: white;
  display: flex;
  flex-direction: column;
  row-gap: 10px;
  justify-content: center;
  padding: 20px 10px;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  @media (min-width: 720px) {
    border-radius: 10px;
  }

  box-shadow: 0 -3px 16px 0 rgba(0, 0, 0, 0.36);
  background-image: linear-gradient(to bottom, #fffce2, #fbfdfe 38%);

  .ImageSection {
    display: flex;
    margin: auto;
    position: absolute;
    top: -40px;
    left: calc(50% - 40px);
  }
  .title {
    font-size: 20px;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.87);
    margin-top: 40px;
    @media (min-width: 720px) {
      font-size: 22px;
    }
  }
  .amountSave {
    font-size: 32px;
    font-weight: bold;
    color: #1fa577;
    span {
      font-weight: 500;
    }
  }
  .coupon {
    font-size: 18px;
    font-weight: 500;
    color: #1fa577;
    span {
      font-weight: 600;
    }
  }
  .info {
    //   opacity: 0.67;
    font-size: 12px;
    color: #000;
    margin: 10px 0 25px;
  }
  button {
    outline: none;
    border-radius: 6px;
    position: relative;
    @media (min-width: 720px) {
      cursor: pointer;
    }
    font-family: 'Montserrat';
    flex-basis: 48%;
    @media (min-width: 720px) {
      flex-basis: 40%;
    }
  }
  .buttonCover {
    display: flex;
    justify-content: space-between;
    @media (min-width: 720px) {
      justify-content: space-evenly;
    }
  }
  .leave {
    padding: 12px;
    box-shadow: 1px 2px 6px 0 rgba(0, 0, 0, 0.16);
    background-color: #fff;
    border: 1px solid #dc5a62;
    font-size: 14px;
    font-weight: 600;
    color: #dc5a62;
  }
  .stay {
    padding: 12px;
    border-radius: 8px;
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
    background-color: #ef4e5e;
    border: none;
    font-size: 14px;
    font-weight: 600;
    color: #fff;
    ${ShimmerEffect}
  }
  img {
    filter: drop-shadow(0px 0px 2px rgba(98, 98, 98, 0.5));
  }
  .lowOpacity {
    opacity: 0.6;
  }
`;
